import React, { useState } from 'react'
import { ChevronDown } from 'lucide-react'

interface FaqItem {
  question: string
  answer: string
}

const FAQ_ITEMS: FaqItem[] = [
  {
    question: 'How does it arrive frozen?',
    answer:
      'The product is packed in an insulated Uline shipper with dry ice and shipped UPS 2-Day Air, arriving frozen solid.',
  },
  {
    question: 'What is the minimum order?',
    answer:
      'The minimum is 30 tails (1 kit) with no maximum cap. Palletized options are available for delivery via the Cold-chain LTL network upon request.',
  },
  {
    question: 'How do I prepare them?',
    answer:
      'Straight from frozen with no thawing needed. Drop in a 325°F deep fryer for exactly 5 minutes.',
  },
  {
    question: 'What is the shelf life?',
    answer:
      '8 months from the ship date when kept frozen at 0°F or below.',
  },
]

const WholesaleFaq: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index))
  }

  return (
    <section className="relative z-10" style={{ backgroundColor: '#111111' }}>
      <div className="container mx-auto px-6 py-8 max-w-6xl">
        <h2 className="text-3xl md:text-4xl font-bold !text-white font-heading text-center mb-10">
          Questions, Answered
        </h2>

        <div className="max-w-3xl mx-auto flex flex-col gap-4">
          {FAQ_ITEMS.map((item, index) => {
            const isOpen = openIndex === index
            const panelId = `wholesale-faq-panel-${index}`
            const buttonId = `wholesale-faq-button-${index}`

            return (
              <div
                key={item.question}
                className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden"
              >
                <button
                  id={buttonId}
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                  onClick={() => toggle(index)}
                  className="w-full flex items-center justify-between gap-4 text-left p-5 md:p-6"
                >
                  <span className="text-base md:text-lg font-semibold !text-white font-heading">
                    {item.question}
                  </span>
                  <ChevronDown
                    aria-hidden="true"
                    className={`flex-shrink-0 w-5 h-5 !text-white/60 transition-transform duration-300 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  />
                </button>

                <div
                  id={panelId}
                  role="region"
                  aria-labelledby={buttonId}
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-5 md:px-6 pb-5 md:pb-6 !text-white/70 font-body leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default WholesaleFaq
